<template>
  <div class="news">
    <banner title="物流工具" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>智能算箱排柜系统</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>TMS运输系统</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 3}"
            @click="newstype = 3 "
          >
            <span>智能制单系统</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 4}"
            @click="newstype = 4 "
          >
            <span>仓储系统</span>
          </div>
        </div>
        <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <p class="item-list-content">{{item.Content}}</p>
          </div>
        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import img1 from '@/assets/img/tools1.png'
import img2 from '@/assets/img/tools2.png'
import img3 from '@/assets/img/tools3.png'
import img4 from '@/assets/img/tools4.png'
export default {
  name: "ShowCase",
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      newsList: [
        {
          Content:'智能装箱系统运用 AI 算法自动优化货物摆放，最大化容器空间利用率，提升装箱效率与装载合理性，是高效实用的智能物流解决方案。点击即可免费算箱排柜，https://www.optimalpacking.cn/',
          Img:img1
        }
      ],
      newstype: 1
    };
  },
  methods: {
  },
  mounted() {

  },
  watch: {
    newstype(type) {
      window.console.log(type);
      if(type==1) {
        this.newsList = [
        {
          Content:' 智能装箱系统运用 AI 算法自动优化货物摆放，最大化容器空间利用率，提升装箱效率与装载合理性，是高效实用的智能物流解决方案。点击即可免费算箱排柜，https://www.optimalpacking.cn/',
          Img:img1
        }
        
        ]
      }
      if(type==2) {
        this.newsList = [
        {
          Content:'TMS（运输管理系统）主要适用于‌物流企业、货运公司、第三方物流服务商（3PL）、大型制造商等，该系统基于实时路况、车辆状态等数据自动匹配最优路线与运力，实现从接单到签收的全流程可视化，并自动处理运单分配、费用结算等环节，显著提升物流效率与客户满意度。联系客服17318410357即可免费体验',
          Img:img2
        }
        
        ]
      }
      if(type==3) {
        this.newsList = [
        {
          Content:' 适用于贸易公司和报关企业的制单、审单业务，本系统采用多模态大模型、RAG、图像识别等先进的人工智能技术，快速识别任意格式的报关资料(报关草单、发票、装箱单、合同、申报要素等)，将其转化为结构化数据，告别手动录单，大大提高通关效率，降低通关成本，减少人为错误。联系客服17318410357即可免费体验。',
          Img:img3
        }
        
        ]
      }
      if(type==4) {
        this.newsList = [
        {
          Content:'以进场编号为维度，管理仓库进库、出库、装箱、盘点、结算作业，融合扫码枪、RFID、PDA等设备，采用线上线下业务结合模式，提升原有作业效率和精准度。联系客服17318410357即可免费体验',
          Img:img4
        }
        
        ]
      }
            
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.item-list-content {
  padding: 0 10px;
  font-size: 16px;
}
.news {
  width: 100%;
  height: 100%;
  background: url(../assets/img/b3.jpg) repeat center;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 830px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 100%;
          height: 500px;
          margin: 10px 10px;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 100%;
            height:100%;
            background-color: #fff;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>